import CameraIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/camera';
import {
  BpkBox,
  BpkBreakpoint,
  BpkFlex,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import STYLES from './ImageCaption.module.scss';

type ImageCaptionProps = {
  credit?: {
    label: string;
    altText: string;
  };
  description?: string;
  title?: string;
};

// Breakpoint mapping:
// .ImageCaption @include bpk-breakpoint-small-tablet → max-width 768px (SCSS)
// Mobile-first equivalent: base (≤768px) → column; tablet (≥769px) → row
// gap: base → bpk-spacing-md (8px); tablet → bpk-spacing-lg (24px)

const ImageCaption = ({
  credit = undefined,
  description = '',
  title = '',
}: ImageCaptionProps) => {
  if (!(credit || description || title)) {
    return null;
  }

  return (
    <BpkFlex
      data-testid="caption"
      marginTop={BpkSpacing.Base}
      justify="space-between"
      direction={{ base: 'column', [BpkBreakpoint.Tablet]: 'row' }}
      gap={{ base: BpkSpacing.MD, [BpkBreakpoint.Tablet]: BpkSpacing.LG }}
    >
      {(title || description) && (
        <BpkBox>
          <BpkText tagName="p" textStyle={TEXT_STYLES.caption}>
            {title && (
              <BpkBox as="span" display="inline-block">
                <BpkText tagName="span" textStyle={TEXT_STYLES.label3}>
                  {title}
                </BpkText>
              </BpkBox>
            )}{' '}
            {description}
          </BpkText>
        </BpkBox>
      )}
      {credit && (
        <BpkFlex gap={BpkSpacing.SM} grow={0} flexShrink={0}>
          {/* Icon margin-top uses a negative sub-token value (-0.125rem) that
              BpkMarginValue does not support; kept in SCSS via className. */}
          <CameraIcon aria-hidden className={STYLES.Icon} />
          <BpkText
            tagName="p"
            textStyle={TEXT_STYLES.caption}
            aria-label={credit.altText}
          >
            {credit.label}
          </BpkText>
        </BpkFlex>
      )}
    </BpkFlex>
  );
};
export default ImageCaption;
